import styled from 'styled-components'

import Drawer from '../Drawer/Drawer'
import Button from '../Button/Button'

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 27px;
  padding: 50px;
  max-width: 544px;
  width: 100%;
  background: var(--color-bg-sidebar);
  border-radius: 4px;
  border: 2px solid var(--color-bg-sidebar);
`

const Title = styled.h1`
  color: var(--color-text-primary);
  font-weight: 900;
  font-size: 24px;
  line-height: 1;
`

const Text = styled.span`
  color: var(--color-text-secondary);
  font-size: 14px;
`

const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`

const StyledButton = styled(Button)`
  background-color: ${p => (p.light ? 'rgba(151, 202, 111, 0.2)' : 'var(--color-primary)')};
  color: ${p => (p.light ? 'var(--color-primary)' : 'var(--color-bg-main)')};
  font-weight: bold;
  padding: ${p => (p.light ? '10px 19px' : '10px 32px')};
  border-radius: 4px;

  ${p => p.center && 'align-self: center'};

  &:hover { 
    background-color: ${p => (p.light ? 'var(--color-primary)' : 'var(--color-secondary)')};
    color: var(--color-bg-main); 
  } 
`

const ConfirmationModal = ({
  isOpen,
  toggle,
  title,
  neutralBtnText = "cancel",
  positiveBtnText = "save",
  message,
  handler,
  submitting
}) => {
  const handleSubmit = async () => {
    try {
      await handler();
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Drawer isOpen={isOpen}>
      <Box className="confirmation-modal">
        <Title>{title}</Title>
        <Text dangerouslySetInnerHTML={{__html: message }} />
        <ButtonRow>
          <StyledButton fontSize="10px" light onClick={toggle} className='confirmation-modal-close-btn'>
            {neutralBtnText}
          </StyledButton>
          <StyledButton
            fontSize="10px"
            className='confirmation-modal-save-btn'
            onClick={handleSubmit}
            isSubmitting={submitting}
          >
            {positiveBtnText}
          </StyledButton>
        </ButtonRow>
      </Box>
    </Drawer>
  )
}

export default ConfirmationModal
